(ns renolit-roofing-service.layout.info-bar
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]))

(def default-info-bar-opts
  {:success {:disappear-in-ms 5000}
   :error {:disallow-repeated? true}})

(def bar-type-icon-keys
  {:error :error
   :info :info
   :success :success
   :warning :warning})

(defn- build-info-bar-data
  [{:keys [message msg-transl-kw type] :as opts}]
  (merge
   (get default-info-bar-opts type)
   (assoc opts
          :message (or (t [msg-transl-kw]) message)
          :id (random-uuid))))

(defn same-info-bar?
  [a b]
  (= (dissoc a :id)
     (dissoc b :id)))

(rf/reg-sub
 ::info-bars
 (fn [db _]
   (:info-bars db)))

(defn- remove-info-bars
  [info-bars {:keys [id context type]}]
  (let [conditions (cond-> []
                     id (conj #(= id (:id %)))
                     type (conj #(= type (:type %)))
                     context (conj #(= context (:context %))))]
    (->> info-bars
         (remove
          (fn [info-bar]
            (every? #(% info-bar) conditions)))
         (vec))))

(rf/reg-event-db
 ::remove-info-bars
 (fn [db [_ opts]]
   (update db :info-bars remove-info-bars opts)))

(rf/reg-event-db
 ::remove-all-info-bars
 (fn [db _]
   (dissoc db :info-bars)))

(rf/reg-event-fx
 ::add-info-bar
 (fn [{:keys [db]} [_ info-bar-opts]]
   (let [{:keys [id disallow-repeated? disappear-in-ms] :as info-bar}
         (build-info-bar-data info-bar-opts)]
     {:db (cond-> db
            disallow-repeated?
            (update :info-bars #(vec (remove (partial same-info-bar? info-bar) %)))
            :always
            (update :info-bars #(vec (conj % info-bar))))
      :fx (cond-> []
            disappear-in-ms
            (conj [:dispatch-later {:ms disappear-in-ms
                                    :dispatch [::remove-info-bars {:id id}]}]))})))

(defn main []
  (let [info-bars (rf/subscribe [::info-bars])]
    (fn []
      (when (seq @info-bars)
        [:div.info-bar-container
         (for [{:keys [id type message custom-icon-key]} (reverse @info-bars)]
           ^{:key id}
           [:div.info-bar
            {:class (str "info-bar--" (name type))}
            [:div.info-bar__msg
             [layout.icon/icon
              {:key (or custom-icon-key (get bar-type-icon-keys type))
               :class "info-bar__type-icon"}]
             [:span message]]
            [:button.flat-btn.info-bar__close-btn
             {:on-click (fn [e]
                          (.preventDefault e)
                          (rf/dispatch [::remove-info-bars {:id id}]))}
             [layout.icon/icon
              {:key :close
               :class "info-bar__close-icon"
               :clickable? true}]]])]))))
